<template>
    <Layout>
        <div class="row">
            <div class="col-lg-12">
                <div class="card border border-radius-12">
                    <div class="card-body mb-0">
                        <div class="toolbar-container px-3">
                            <div class="toolbar-row d-flex align-items-center justify-content-between mb-4">
                                <PageHeader :title="title" :items="itemsBreadcrumb"
                                    class="poppins fw-normal ps-0 text-nowrap" />
                            </div>

                            <div class="toolbar-row d-flex gap-2 align-items-center">
                                <searchInput @getSearched="handleSearch" class="p-0" />
                                <pageSize @getPageSize="handlePageSize" class="page-size-btn p-0" />
                            </div>
                        </div>

                        <div class="inner overflow-auto position-relative px-3 pb-3">
                            <div v-if="processing"
                                class="w-100 h-100 d-flex align-items-center justify-content-center processing-overlay">
                                <APILoader :loading="processing" class="align-middle text-center" />
                            </div>

                            <div v-if="!processing && (!items || items.length === 0)" class="text-center py-4">
                                <p class="mb-0 text-muted">No Activity Logs Exists</p>
                            </div>

                            <div v-for="log in items" :key="log.id"
                                class="d-flex justify-content-between gap-md-3 gap-2 darkBorder">
                                <div class="user-comment w-100">
                                    <div class="info__user">
                                        <div class="d-flex justify-content-between align-items-center">
                                            <div class="comment-options d-flex">
                                                <p class="mb-0 text-break">

                                                    <span class="grey-bg px-2 rounded-pill"
                                                        v-html="log.description_html"></span>


                                                </p>
                                                <a href="#" class="view-link" @click.prevent="openLog(log.id)">
                                                    View Detail
                                                </a>

                                            </div>

                                            <div class="d-flex align-items-center gap-2">
                                                <span class="comment-date fs-14">
                                                    {{ log.created_at }}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="text-center pt-4">
                                <Pagination v-if="paginate && paginate.total > 0" @paginator="getActivities"
                                    :pagination="paginatelinks" :showing="paginate" @page-changed="handlePageChange" />
                            </div>
                        </div>

                        <b-modal ref="activity-modal" hide-footer isModalVisible title="Activity Details" size="lg">
                            <template v-slot:default>
                                <div v-if="detailLoading">
                                    <APILoader :loading="detailLoading" class="align-middle text-center" />
                                </div>

                                <div v-else>
                                    <div v-if="selectedActivity">
                                        <div class="mb-2">
                                            <strong>User:</strong>
                                            {{ selectedActivity?.user?.name || selectedActivity?.user?.full_name ||
                                                selectedActivity.causer_id || "N/A" }}
                                        </div>

                                        <div class="mb-2">
                                            <strong>Description:</strong>
                                            <span v-html="cleanDescription(selectedActivity.description)"></span>
                                        </div>

                                        <div class="mb-2">
                                            <strong>Created At:</strong>
                                            {{ selectedActivity.created_at || "N/A" }}
                                        </div>

                                        <div class="mt-3">
                                            <strong>Properties:</strong>
                                            <div class="properties-box">
                                                <div v-for="(row, idx) in flattenProperties(selectedActivity.properties)"
                                                    :key="idx" class="property-row">
                                                    <div class="property-key">{{ row.key }}</div>
                                                    <div class="property-value">{{ row.value }}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div v-else class="text-center">
                                        <p>No activity data available.</p>
                                    </div>
                                </div>
                            </template>
                        </b-modal>

                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>

<script>
import Layout from "../../../layouts/static/main";
import PageHeader from "@/components/static/page-header";
import appConfig from "@/app.config";
import Pagination from "../../../../components/general/pagination.vue";
import searchInput from "../../../../components/general/searchInput.vue";
import pageSize from "../../../../components/general/pageSize.vue";
import APILoader from "@/components/general/APILoader.vue";

export default {
    page: {
        title: "Activity Logs",
        meta: [{ name: "activity-logs", content: appConfig.description }],
    },

    components: {
        Layout,
        PageHeader,
        Pagination,
        searchInput,
        pageSize,
        APILoader,
    },

    data() {
        return {
            title: "Activity Logs",

            items: [],
            processing: false,

            paginate: {},
            paginatelinks: [],
            pageSize: 25,
            search: null,

            selectedActivity: null,
            detailLoading: false,
        };
    },

    computed: {
        itemsBreadcrumb() {
            return [{ text: "Omaha" }, { text: "Activity Logs", active: true }];
        },
    },

    mounted() {
        let url = null;
        if (this.$route.query.currentPage) {
            url = `activity-logs?page=${this.$route.query.currentPage}`;
        }
        this.getActivities({ url, pageSize: this.pageSize });
        this.processing = true;
    },

    methods: {
        openModal() {
            this.$refs["activity-modal"].show();
        },

        handleSearch(searchItem) {
            this.search = searchItem;
            this.getActivities({ searchItem, pageSize: this.pageSize });
        },

        handlePageSize(newPageSize) {
            this.pageSize = newPageSize || 25;
            this.getActivities({ pageSize: this.pageSize, searchItem: this.search });
        },

        handlePageChange(pageNumber) {
            const baseUrl = "activity-logs";
            const pageUrl = `${baseUrl}?page=${pageNumber}`;
            this.getActivities({
                url: pageUrl,
                pageSize: this.pageSize,
                searchItem: this.search,
            });
        },

        formatDate(dateTime) {
            if (!dateTime) return "N/A";

            const date = new Date(dateTime.replace(" ", "T"));
            if (isNaN(date)) return dateTime;

            return date.toLocaleString("en-GB", {
                day: "2-digit",
                month: "short",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
                hour12: true,
            });
        },

        cleanDescription(text) {
            if (!text) return "N/A";
            return String(text).replace(/App\\Models\\/g, "");
        },

        randerData(response) {
            const payload = response?.data || {};

            this.paginate = {
                first_page: payload.first_page_url,
                last_page_url: payload.last_page_url,
                last_page: payload.last_page,
                links: payload.links,
                from: payload.from,
                to: payload.to,
                total: payload.total,
            };

            this.paginatelinks = (this.paginate.links || []).map((item) => ({
                url: item.url,
                label: item.label,
                active: item.active,
            }));

            const rows = Array.isArray(payload?.data) ? payload.data : [];

            this.items = rows.map((row) => ({
                id: row.id,
                user: row?.user?.name || row?.user?.full_name || row.causer_id || "N/A",
                description_html: this.cleanDescriptionForListing(row.description || "N/A"),
                created_at: this.formatDate(row.created_at),
            }));

            this.processing = false;
        },

        getActivities({ url = null, searchItem = null, pageSize = this.pageSize } = {}) {
            this.processing = true;

            let endPoint = "activity-logs";
            endPoint = url ? url : endPoint;

            const params = {
                search: searchItem,
                per_page: pageSize,
            };

            this.$axios
                .get(endPoint, { params })
                .then((response) => {
                    setTimeout(() => this.randerData(response), 250);
                })
                .catch((error) => {
                    console.log(error?.response || error);
                    this.processing = false;
                });
        },

        openLog(activityId) {
            this.detailLoading = true;
            this.selectedActivity = null;

            this.$axios
                .get(`activity-logs/${activityId}`)
                .then((response) => {
                    this.selectedActivity = response?.data?.data || null;
                    this.detailLoading = false;
                    this.openModal();
                })
                .catch((error) => {
                    console.log(error?.response || error);
                    this.detailLoading = false;
                });
        },

        cleanDescriptionForListing(text) {
            if (!text) return "N/A";

            let s = String(text);
            s = s.replace(/App\\Models\\/g, "");
            s = s.replace(/\sfrom\s*<b>.*?<\/b>\s*to\s*<b>.*?<\/b>/gi, "");
            s = s.replace(/\sfrom\s+\S[\s\S]*?\s+to\s+\S[\s\S]*?(?=$|<)/gi, "");
            s = s.replace(/\s{2,}/g, " ").trim();

            return s || "N/A";
        },

        flattenProperties(props) {
            if (!props) return [];

            let obj = props;

            if (typeof obj === "string") {
                try {
                    obj = JSON.parse(obj);
                } catch (e) {
                    return [{ key: "properties", value: obj }];
                }
            }

            if (typeof obj !== "object" || obj === null) {
                return [{ key: "properties", value: String(obj) }];
            }

            const rows = [];
            const hiddenKeys = ["added_by", "object"];

            const keys = Object.keys(obj).sort((a, b) => a.localeCompare(b));

            keys.forEach((k) => {
                if (hiddenKeys.includes(k)) return;

                let value = obj[k];

                if (typeof value === "object") return;

                if (value === null || value === undefined || value === "") {
                    value = "N/A";
                }

                if (typeof value === "boolean") {
                    value = value ? "Yes" : "No";
                }

                if (
                    String(k).toLowerCase().includes("token") &&
                    typeof value === "string"
                ) {
                    value =
                        value.length > 16
                            ? `${value.slice(0, 8)}...${value.slice(-6)}`
                            : value;
                }

                rows.push({ key: k, value: String(value) });
            });

            return rows;
        },
    },
};
</script>

<style scoped>
.bg-orange {
    background-color: #ec421c;
}

.white {
    color: #fff;
}

.toolbar-container {
    margin-bottom: 1.5rem;
    display: flex;
    flex-direction: column;
}

.toolbar-row {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    align-items: center;
    width: 100%;
}

.inner {
    min-height: 180px;
}

.processing-overlay {
    position: absolute;
    inset: 0;
    background: rgba(255, 255, 255, 0.65);
    z-index: 10;
}

.darkBorder {
    border-bottom: 1px solid #eee;
    padding: 14px 0;
}

.grey-bg {
    background: #f2f2f2;
}

.comment-date {
    white-space: nowrap;
}

.properties-box {
    width: 100%;
    max-height: 45vh;
    overflow: auto;
    border: 1px solid #ddd;
    border-radius: 10px;
    background: #fff;
    padding: 10px;
}

.property-row {
    display: flex;
    gap: 12px;
    padding: 8px 0;
    border-bottom: 1px solid #eee;
}

.property-row:last-child {
    border-bottom: 0;
}

.property-key {
    width: 180px;
    font-weight: 600;
    color: #444;
    word-break: break-word;
}

.property-value {
    flex: 1;
    color: #222;
    word-break: break-word;
}

.view-link {
    color: #ec421c;
    text-decoration: underline !important;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
}

.view-link:hover {
    opacity: 0.85;
}


@media (max-width: 576px) {
    .card-body {
        padding: 0.25rem !important;
    }

    .toolbar-row:first-child {
        flex-direction: column;
        align-items: flex-start;
    }
}
</style>
